document.addEventListener("DOMContentLoaded", function () {
  // CSS セレクターを使わず DOM プロパティ比較で安全に検索
  const getFacetsInput = (filterName, filterValue) => {
    const selectors = ["#FacetFiltersForm", "#FacetFiltersFormMobile"];
    for (const id of selectors) {
      const form = document.querySelector(id);
      if (!form) continue;
      for (const input of form.querySelectorAll('input[type="checkbox"]')) {
        if (input.name === filterName && input.value === filterValue)
          return input;
      }
    }
    return null;
  };

  // 同じ filter name で異なる value の facets inputs（在庫切れ側）を返す
  const getConflictingFacetsInputs = (filterName, excludeValue) => {
    const selectors = ["#FacetFiltersForm", "#FacetFiltersFormMobile"];
    const results = [];
    for (const id of selectors) {
      const form = document.querySelector(id);
      if (!form) continue;
      for (const input of form.querySelectorAll('input[type="checkbox"]')) {
        if (input.name === filterName && input.value !== excludeValue)
          results.push(input);
      }
    }
    return results;
  };

  // --- 売り切れを除外スイッチ ---
  // AJAX再描画でDOMが差し替わっても機能するよう毎回DOMを再取得するヘルパー
  const getSwitchCheckbox = () =>
    document.querySelector(
      ".js-availability-filter-switch input[type='checkbox']",
    );

  // 初期ロード時: 在庫なしが URL パラメーターに含まれていたらスイッチを OFF にする
  const switchCheckboxInit = getSwitchCheckbox();
  if (switchCheckboxInit) {
    const conflictingOnLoad = getConflictingFacetsInputs(
      switchCheckboxInit.dataset.filterName,
      switchCheckboxInit.dataset.filterValue,
    ).some((input) => input.checked);
    if (conflictingOnLoad && switchCheckboxInit.checked) {
      switchCheckboxInit.checked = false;
    }
  }

  // change イベントを document に委譲: AJAX再描画後の新しい要素にも機能する
  document.addEventListener("change", function (e) {
    if (!e.target.closest(".js-availability-filter-switch")) return;
    const sw = e.target;
    const filterName = sw.dataset.filterName;
    const filterValue = sw.dataset.filterValue;

    if (sw.checked) {
      // ケース2: switch ON → 在庫切れ側の facets inputs をイベントなしで外す
      const conflicting = getConflictingFacetsInputs(filterName, filterValue);
      const hadConflicting = conflicting.some((input) => input.checked);
      conflicting.forEach((input) => {
        if (input.checked) input.checked = false;
      });

      const facetsCheckbox = getFacetsInput(filterName, filterValue);
      if (facetsCheckbox) {
        if (hadConflicting && facetsCheckbox.checked) {
          // 在庫あり・在庫なし両方チェック済みだったケース:
          // facetsCheckbox.checked がすでに true のため click() がスキップされる。
          // 一旦 false に戻してから click() し、conflicting を除いた正しい状態で再送信する。
          facetsCheckbox.checked = false;
          facetsCheckbox.click();
        } else if (!facetsCheckbox.checked) {
          facetsCheckbox.click();
        }
      }
      return;
    }

    const facetsCheckbox = getFacetsInput(filterName, filterValue);
    if (facetsCheckbox && facetsCheckbox.checked !== sw.checked) {
      facetsCheckbox.click();
    }
  });

  // ローディング中はスイッチを無効化
  // #ProductGridContainer を監視: innerHTML 置き換え後も最新の .collection を参照する
  const productGridContainer = document.getElementById("ProductGridContainer");
  if (productGridContainer) {
    const updateSwitchDisabled = () => {
      const sw = getSwitchCheckbox();
      if (!sw) return;
      const collectionEl = productGridContainer.querySelector(".collection");
      const isLoading = collectionEl
        ? collectionEl.classList.contains("loading")
        : false;
      sw.disabled = isLoading;
      const switchLabel = sw.closest(".js-availability-filter-switch");
      if (switchLabel) switchLabel.classList.toggle("disabled", isLoading);
    };
    new MutationObserver(updateSwitchDisabled).observe(productGridContainer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }

  // ケース1: 絞り込みフィルターで在庫切れがチェックされたとき switch を OFF にする
  // capture: true で facets.js より先に実行し、在庫ありを外してから facets.js に処理させる
  document.addEventListener(
    "input",
    function (e) {
      const target = e.target;
      if (!target || target.tagName !== "INPUT" || target.type !== "checkbox")
        return;
      if (!target.closest("#FacetFiltersForm, #FacetFiltersFormMobile")) return;
      const sw = getSwitchCheckbox();
      if (!sw) return;
      if (target.name !== sw.dataset.filterName) return;
      if (target.value === sw.dataset.filterValue) return;

      if (target.checked) {
        // 在庫切れがチェックされた → 在庫ありの facets input を外し switch を OFF に
        const availInput = getFacetsInput(
          sw.dataset.filterName,
          sw.dataset.filterValue,
        );
        if (availInput && availInput.checked) availInput.checked = false;
        if (sw.checked) sw.checked = false;
      }
    },
    true,
  ); // capture: true → facets.js のバブルリスナーより先に実行

  // --- カテゴリフィルター ---
  // change イベントを document に委譲: AJAX再描画後の新しい要素にも機能する
  document.addEventListener("change", function (e) {
    if (!e.target.classList.contains("category-filter-checkbox")) return;
    const checkbox = e.target;
    const facetsCheckbox = getFacetsInput(
      checkbox.dataset.filterName,
      checkbox.dataset.filterValue,
    );
    if (facetsCheckbox && facetsCheckbox.checked !== checkbox.checked) {
      facetsCheckbox.click();
    }
  });

  // facets AJAX再描画後 → 各フィルターの状態を同期
  const filtersContainer = document.querySelector(
    "#main-collection-filters, #main-search-filters",
  );
  if (filtersContainer) {
    new MutationObserver(function () {
      const sw = getSwitchCheckbox();
      if (sw) {
        const filterName = sw.dataset.filterName;
        const filterValue = sw.dataset.filterValue;

        // 在庫切れ（conflicting な availability option）がチェックされていたら強制 OFF
        const conflictingChecked = getConflictingFacetsInputs(
          filterName,
          filterValue,
        ).some((input) => input.checked);

        if (conflictingChecked) {
          if (sw.checked) sw.checked = false;
        } else {
          // 在庫切れが未選択の場合のみ在庫ありの状態に同期
          const facetsCheckbox = getFacetsInput(filterName, filterValue);
          if (facetsCheckbox && sw.checked !== facetsCheckbox.checked) {
            sw.checked = facetsCheckbox.checked;
          }
        }
      }
      document
        .querySelectorAll(".category-filter-checkbox")
        .forEach(function (checkbox) {
          const facetsCheckbox = getFacetsInput(
            checkbox.dataset.filterName,
            checkbox.dataset.filterValue,
          );
          if (facetsCheckbox && checkbox.checked !== facetsCheckbox.checked) {
            checkbox.checked = facetsCheckbox.checked;
          }
        });
    }).observe(filtersContainer, { childList: true, subtree: true });
  }
});
